import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f3128b1"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3128b1')) {
      api.createRecord('7f3128b1', component.options)
    } else {
      api.reload('7f3128b1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f3128b1", function () {
      api.rerender('7f3128b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Generator/components/RelationFormAttr/index.vue"
export default component.exports